export const MAINPAGE_ROUTE = '/main'
export const LINKSPAGE_ROUTE = '/links'
export const GRAPHPAGE_ROUTE = '/Graph'
export const PRICEPAGE_ROUTE = '/price'
export const SETTINGPAGE_ROUTE = '/setting'
export const ERRORPAGE_ROUTE = '/error'
export const LOGINPAGE_ROUTE = '/login'
export const REGPAGE_ROUTE = '/registration'
export const FAQ_ROUTE = '/faq'
